export default "__VITE_ASSET__DJ3W2a6U__"